import { Avatar, Button, Card, Checkbox, Modal, Select, Statistic, Tag, TreeSelect } from 'antd'
import React, { useEffect, useState } from 'react'
import { api, app, config } from 'xadmin'
import { Model } from 'xadmin-model'
import { C, Icon } from 'xadmin-ui'
import Charts from './EChart'

//图表组件
const EchartsTest = ({ id, chart }) => {
  const [ option, setOption ] = useState()

  useEffect(()=>{
    initData()
    getOption()
  }, [ chart, id ])

  const initData = () => {
    //查询资产的状态（在线，掉线，断电）
    let queryStr = encodeURIComponent(JSON.stringify({ modelIds: [ id ], allData: true }))
    api({ name: 'core/status/stats' })
      .fetch('?query=' + queryStr, {})
      .then(({ json })=>{
        setOption(json)
      })
  }

  const getOption = () => {
    let yData; let xData;
    if(option&&option.length) {
      yData = Object.values(option[0]).splice(2)
      xData = Object.keys(option[0]).splice(2)
    } 
    if(chart == 'bar') {
      
      // 绘制柱状图图表
      return {
        tooltip: {},
        xAxis: {
          type: 'category',
          data: xData || []
        },
        yAxis: {
          type: 'value'
        },
        series: [ {
          type: chart,
          data: yData || []
        } ]
      }
    }else if(chart == 'pie') {
      // 绘制图表
      return {
        tooltip: {},
        series: [ {
          type: chart,
          radius: [ '50%', '70%' ],
          label: { //  饼图图形上的文本标签                         
            normal: { // normal 是图形在默认状态下的样式                            
              position: 'inner',
              show : false
            }
          },
          data: [
            { name: '在线', value: option && option.length && option[0].online }, 
            { name: '掉线', value: option && option.length && option[0].offline }, 
            { name: '断电', value: option && option.length && option[0].off }
          ] || []
        } ]
      }
    }
  }

  return (<Charts option={ getOption() } />)
}

const { TreeNode } = TreeSelect

const treeData = [
  {
    title: '在线状态',
    key: '0',
    children: [
      {
        title: '在线',
        key: '01',
        value: 'online'
      },
      {
        title: '掉线',
        key: '02',
        value: 'offline'
      },
      {
        title: '断电',
        key: '03',
        value: 'off'
      },
      {
        title: '在线率',
        key: '04',
        value: 'onlineRate'
      }
    ]
  },
  {
    title: '报警数量',
    key: '1',
    value: 'warning'
  },
];
//在线状态报警配置
const MessageSelect = (props) => {
  const { input: { onChange, value } } = props

  const addMessage = (value) => {
    // console.log(value)
    if(value)
      onChange(value)
  }

  const getTreeNode = treeData => treeData.map(item=>{
    if(item.children) {
      return <TreeNode value={item.value} title={item.title} key={item.key} disable={true}>{getTreeNode(item.children)}</TreeNode>
    }
    return <TreeNode value={item.value} title={item.title} key={item.key}></TreeNode>
  })
 
  return (
    <TreeSelect
      showSearch
      value={ value || [] }
      width="350px"
      dropdownStyle={{ maxHeight: 400, overflow: 'auto',width:'100%'  }}
      placeholder="请选择"
      treeData={treeData}
      allowClear
      multiple
      treeDefaultExpandAll
      treeCheckStrictly={true} 
      onChange={(value)=>{addMessage(value)}}
    >
      { getTreeNode(treeData) }
    </TreeSelect>
  )
}
//图表配置
const EchartsSetting = props => {
  const { input: { onChange, value } } = props
  const [ checked, setChecked ] = useState()

  const handleChange = (value) =>{
    onChange(value)
  }

  const checkChange = (e) => {
    // console.log(e.target.checked)
    onChange(e.target.checked)
    setChecked(e.target.checked)
  }

  return (
    <>
      <Checkbox onChange={(e)=>{checkChange(e)}} checked={value || checked }>是否显示图表</Checkbox>
      {
        value && (<Select style={{ width: 120 }} onChange={(value)=>{handleChange(value)}} value={value}>
          <Select.Option value="bar">柱状图</Select.Option>
          <Select.Option value="pie">饼图</Select.Option>
        </Select>)
      }
    </>
  )
}
//按钮的配置
const NodeButton = props => {

  const onModelClick = () => {
    let model = props.model
    app.go('/app/nodes?model=' + model.id)
  }

  return (
    <>
      {
        <Button style={{ marginTop: 16 }} type="primary" size="small" onClick={()=>{onModelClick()}}>查看资产</Button>
      }
    </>
  )
}

const AvatarIcon = (props) => {
  if (props.icon) {
    return <Avatar size={25} shape="square" src={config('mediaUrl') + props.icon} style={{ margin: '0 10px 3px 0' }} />
  } else {
    return <Avatar size={25} shape="square" style={{ margin: '0 10px 3px 0' }}>M</Avatar>
  }
}

//在线状态
const StatusTag = ({ color, type, model, children }) => {
  const [ show, isShow ] = React.useState(false)
  const filter = { model }
  const key = `"StatusNodes-${model.id}-${type}`

  if (type == 'online') {
    filter['online'] = true
    filter['$or'] = [
      { off: false }, { off: { $exists: false } }
    ]
  }
  if (type == 'offline') {
    filter['online'] = false
    filter['$or'] = [
      { off: false }, { off: { $exists: false } }
    ]
  }
  if (type == 'poweroff') {
    filter['off'] = true
  }


  return [
    <Tag color={color} onClick={() => isShow(true)}>{children}</Tag>,
    <Modal visible={show} title={children} width="80%" onCancel={() => isShow(false)} footer={null}>
      <Model name="Node" modelKey={key} initialValues={{ wheres: { filter } }}>
        <div key="model-list-subnav" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '.5rem' }}>
          <C is="Model.Pagination" />
          <C is="Model.ListSubMenu" />
        </div>
        <C is="Model.DataTable" />
      </Model>
    </Modal>
  ]
}

const NodeCard = (props) => {

  const [ stats, setStats ] = useState()
  const [ warningCount, setWarningCount ] = useState()
  const [ nodeCount, setNodeCount ] = useState()

  const { model, bgColor, color, icon, message, chart, lookbtn } = props
  const modelId = model && model.id

  useEffect(()=>{
    if(model) {
      totalCount()
      getData()
    }
  },[ modelId, message ])

  //获取资产总数
  const totalCount = () => {
    if(model) {
      // let queryStr = encodeURIComponent(JSON.stringify({ modelIds: [model.id], allData: true }))
      // api({ name: 'core/status/stats'})
      //   .fetch('?query=' + queryStr, {})
      //   .then(({json})=>{
      //     setStats(json)
      //   })

      api({ name: 'core/node/count' })
        .fetch('', {})
        .then(({ json })=>{
          setNodeCount(json)
        })
    }
  }

  const getData = () => {
    if(model&&message) {
      let modelId = model.id
      if(message.indexOf('online')> -1 || message.indexOf('offline')> -1 || message.indexOf('off')> -1) {
        getStats(modelId, message)
      }
      if(message.indexOf('warning')> -1) { getWarning(modelId) }
    }
    // onChange(value)
  }
  //查询报警数量
  const getWarning = (modelId) => {
    let queryStr = encodeURIComponent(JSON.stringify({ filter: { modelId: modelId } }))
    api({ name: 'warning/warning/stats' })
      .fetch('?query=' + queryStr, {})
      .then(({ json })=>{
        json && json.length ? setWarningCount(json[0].count) : setWarningCount(0)
      })
  }
  //查询资产的状态（在线，掉线，断电）
  const getStats = (modelId) => {
    let queryStr = encodeURIComponent(JSON.stringify({ modelIds: [ modelId ], allData: true }))
    api({ name: 'core/status/stats' })
      .fetch('?query=' + queryStr, {})
      .then(({ json })=>{
        // console.log(json)
        setStats(json)
      })
  }

  return (
    <div>
      <Model name="Node" modelKey="nodeKey">
        {
          <Card style={{ background: bgColor, color: color }}>{ model ? (
            <>
              <div>
                {
                  (nodeCount && nodeCount.length > 0) ? nodeCount.map(itemCount => {
                    if(itemCount.id == model.id) {
                      return (
                        <>
                          <Statistic
                            title={
                              <span id={itemCount.id} style={{
                                display: 'flex',
                                fontSize: '18px',
                                // color: 'rgba(0,0,0,.45)',
                                color: color,
                                flexGrow: 1,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}>
                                <span className="nodeCard-span" style={{ flex: 1 }}>{itemCount.name}</span>
                              </span>
                            }
                            value={ itemCount.count }
                            valueStyle={{ fontSize: '25px' }}
                            // suffix={
                            //   chart == 'pie' && message || chart == 'bar' && message ? <EchartsTest chart={chart} id={model&&model.id} />: <div></div>
                            // }
                            prefix={<AvatarIcon icon={ icon || itemCount.icon } />}
                          />
                          { chart == 'bar' || chart == 'pie' ? <EchartsTest chart={chart} id={model&&model.id} /> : null }
                          <div style={{ marginTop: stats ? 15 : 0 }}>
                            {
                              message && message.map(opts=>{
                                if(opts == 'warning') {
                                  return <Tag color="red">报警数{warningCount}</Tag>
                                }
                                if(stats) {
                                  return stats.map(item=>{
                                    switch(opts) {
                                      case 'onlineRate': 
                                        return <Tag color="rgba(24, 144, 255, 0.8)"><Icon type="line-chart" /> 在线率{Math.round((!item.online ? 0 : (item.online / (itemCount.count - item.off)) * 100) * 100) / 100}%</Tag>
                                      case 'online': 
                                        return <StatusTag color="#37a965" type="online" model={model}><Icon type="cloud" /> 在线{item.online}</StatusTag>
                                      case 'offline':
                                        return <StatusTag color="#d43030" type="offline" model={model}><Icon type="disconnect" /> 掉线{item.offline}</StatusTag>
                                      case 'off':
                                        return <StatusTag color="#ff8d1a" type="poweroff" model={model}><Icon type="api" /> 断电{item.off}</StatusTag>
                                    }
                                  })
                                }
                              })
                            }
                          </div>
                          { model && lookbtn && <NodeButton {...props}></NodeButton> }
                    
                        </>
                      )
                    }
                  }) : null
                }
              </div>
            </>
          ) : <div description="请选择模型" />}
          </Card>
        }
      </Model>
    </div>
  )
}

export { NodeCard, MessageSelect, EchartsTest, EchartsSetting }

